import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import { HealingOutlined } from '@mui/icons-material';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';

// ---------------------------------------------------------------------------
// Relation options shared between first and second attender fields
// ---------------------------------------------------------------------------
export const RELATION_OPTIONS = [
  { value: '1', label: 'Spouse / வாழ்க்கைத் துணை' },
  { value: '2', label: 'Parent / பெற்றோர்' },
  { value: '3', label: 'Child / குழந்தை' },
  { value: '4', label: 'Sibling / உடன்பிறப்பு' },
  { value: '5', label: 'Friend / நண்பர்' },
  { value: '6', label: 'Other / வேறு' },
];

export const ATTENDER_TYPE_OPTIONS = [
  { value: '1', label: 'Known Attender / தெரிந்த அட்டெண்டர்' },
  { value: '2', label: 'No Attender / அட்டெண்டர் இல்லை' },
];

// ---------------------------------------------------------------------------
// Static field definitions (no dynamic options — those are injected in hook)
// ---------------------------------------------------------------------------

export const ATTENDER_TYPE_FIELD = [
  {
    name: 'attender_type',
    label: 'Attender Type / வருகையாளர் வகை',
    placeholder: 'Select attender type',
    type: 'select',
    tabIndex: 6,
    options: ATTENDER_TYPE_OPTIONS,
    rules: { required: 'Attender type is required' },
    startIcon: <HealingOutlined />,
  },
];

export const ATTENDER_NUMBER_FIELD = [
  {
    name: 'no_of_attenders',
    label: 'Number of Attenders / வருகையாளர்களின் எண்ணிக்கை ',
    placeholder: 'Enter number of attenders (1 or 2)',
    type: 'text',
    tabIndex: 7,
    rules: {
      required: 'Number of attenders is required',
      pattern: {
        value: /^[1-2]$/,
        message: 'Only 1 or 2 attenders are allowed',
      },
    },
    startIcon: <PersonIcon />,
  },
];

/** Build attender fields for first or second attender using an index suffix. */
export const buildAttenderFields = (suffix = '', tabOffset = 8) => [
  {
    name: `attender_name${suffix}`,
    label: suffix
      ? 'Second Attender Name / இரண்டாவது வருகையாளர் பெயர்'
      : 'Attender Name / வருகையாளர் பெயர்',
    placeholder: 'Enter attender name',
    type: 'text',
    tabIndex: tabOffset,
    rules: {
      required: suffix
        ? 'Second attender name is required'
        : 'Attender name is required',
    },
    startIcon: <PersonIcon />,
  },
  {
    name: `attender_relation${suffix}`,
    label: 'Relation with Patient / நோயாளியுடனான உறவு',
    placeholder: 'Enter relation',
    type: 'select',
    tabIndex: tabOffset + 1,
    options: RELATION_OPTIONS,
    rules: { required: 'Relation is required' },
    startIcon: <FamilyRestroomIcon />,
  },
  {
    name: `attender_address${suffix}`,
    label: 'Address / முகவரி',
    placeholder: 'Enter address',
    type: 'text',
    tabIndex: tabOffset + 2,
    multipleLine: true,
    rules: { required: 'Address is required' },
    startIcon: <HomeIcon />,
  },
  {
    name: `attender_phone${suffix}`,
    label: 'Phone Number /  தொலைபேசி எண்',
    placeholder: 'Enter phone number',
    type: 'text',
    tabIndex: tabOffset + 3,
    maxLength: 10,
    showCharCount: false,
    rules: {
      pattern: {
        value: /^[0-9]{10}$/,
        message: 'Please enter a valid 10-digit phone number',
      },
    },
    startIcon: <PhoneIcon />,
  },
];

// Pre-built field arrays for each attender slot
export const FIRST_ATTENDER_FIELDS = buildAttenderFields('', 8);
export const SECOND_ATTENDER_FIELDS = buildAttenderFields('_2', 12);
